export class HubVisitorDataSource {
    public place = 'google';
    public event: string;
    // public isAreaBusiness = false;
    public businessType = 'normal';
    public placeImagesShownCount = 5;
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/models/hub/hub.visitor.data.source.ts